import { DefaultService } from "@/services/DefaultService";
import API from "@/plugins/axios";

class NuevaConstanciaUsoSueloService extends DefaultService {
  
  constructor() {
    super('/nueva-constancia-uso-suelo');
  }

  setNuevaConstanciaUsoSuelo(formData: any, locacion: any): Promise<any>{
    return API.post(this.url + '/create/' + locacion, formData);
  }
}

export default new NuevaConstanciaUsoSueloService;